// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3l1Af","addWidgetButton":"Header_addWidgetButton__36IuB","dashboardTabs":"Header_dashboardTabs__1dUOg","active":"Header_active__3B3Fm"};